import {create} from 'zustand'

export const CustomerContext = create((set) => ({
  customers: [],
  setCustomers: (data) => set({customers: data}),
}))
